import { Component, computed, signal } from '@angular/core';
import {
  LabelFilterDto,
  LabelItemDto,
  LabelService,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { currentTenantId } from '@/utils/admin-utils';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-label-overview-page',
  templateUrl: './label-overview-page.component.html',
  styleUrls: ['./label-overview-page.component.scss'],
})
export class LabelOverviewPageComponent {
  tenantId = currentTenantId();
  form!: FormGroup;

  readonly canCreate = computed(() => this.currentUserService.hasPrivilege('editLabels'));

  readonly loadLabels = (filter: LabelFilterDto) => this.labelService.findAll({ ...filter });
  readonly getCount = (filter: LabelFilterDto) => this.labelService.getCount({ ...filter });

  constructor(
    private readonly labelService: LabelService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  add(): void {
    this.router.navigate(['label', 'new']);
  }

  navigateToLabel(label: LabelItemDto): void {
    this.router.navigate(['label', label.id]);
  }
}
